<template>
  <div class="page jp">
    <CollectionsPage
      :data="this.data"
      :language="'japanese'"
    />
  </div>
</template>

<script>
// @ is an alias to /src
import CollectionsPage from "../components/CollectionsPage.vue";

import { mapMutations } from "vuex";

export default {
  name: "Jp",
  components: { CollectionsPage },
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
  mounted() {
    this.selectedLanguageMutation("Jp");
  },
  methods: {
    ...mapMutations(["selectedLanguageMutation"]),
  },
};
</script>
